<script setup lang="ts">
import { landlordAuthApi } from '@afinius/api-client/landlord-auth/api';
import { useLandlordAuthStore } from '@afinius/hooks/store/useLandlordAuthStore';
import { useLandlordUserStore } from '@afinius/hooks/store/useLandlordUserStore';
import { useTenantStore } from '@afinius/hooks/store/useTenantStore';
import { useSessionRefresh } from '@afinius/hooks/useSessionRefresh';
import Splash from '@afinius/organisms/Splash/Splash.vue';
import Container from '@afinius/ui-framework/Container/Container.vue';
import { ConfigProvider } from 'ant-design-vue';
import nlNL from 'ant-design-vue/es/locale/nl_NL';
import { onMounted } from 'vue';
import { RouterView } from 'vue-router';

import Header from '../../segments/AppHeaderSegment/AppHeaderSegment.vue';

const authStore = useLandlordAuthStore();
const tenantStore = useTenantStore();
const userStore = useLandlordUserStore();
const { isLoading, initializeSession } = useSessionRefresh(authStore, landlordAuthApi.check);

onMounted(async () => {
  await initializeSession();

  if (!tenantStore.tenant) {
    tenantStore.fetchTenant();
  }

  if (!userStore.user) {
    userStore.fetchUser();
  }
});
</script>

<template>
  <ConfigProvider :locale="nlNL">
    <Splash v-if="isLoading" />

    <div v-else class="app-layout">
      <main class="app-layout-main">
        <Header />

        <div class="app-layout-main-content">
          <Container width="lg">
            <RouterView />
          </Container>
        </div>
      </main>
    </div>
  </ConfigProvider>
</template>

<style lang="scss" scoped>
@use './AppLayout.scss';
</style>
